import * as Yup from "yup";
import { BILL_IMAGE_REQUIRED_TYPES } from "../../../constants/billTypes";

export { BILL_IMAGE_REQUIRED_TYPES };

const ALLOWED_FILE_TYPES = [
  "image/jpeg", "image/png", "image/jpg", "image/webp", "application/pdf",
];
const MAX_FILE_SIZE = 5 * 1024 * 1024;

const fileTests = (schema) =>
  schema
    .test("fileSize", "File must be less than 5MB", (v) => !v || v.size <= MAX_FILE_SIZE)
    .test("fileType", "Only JPG, PNG, or PDF allowed", (v) =>
      !v || ALLOWED_FILE_TYPES.includes(v.type)
    );

export const getUploadBillSchema = (billType) => {
  const requiresImage = BILL_IMAGE_REQUIRED_TYPES.includes(billType);

  return Yup.object().shape({
    // FIX: Use Yup.string() + .test() instead of Yup.number().transform()
    // Yup.number().transform() causes a flash "required" error when setFieldValue
    // is called with a valid string like "1230" because the transform briefly
    // returns NaN during the async Formik validation cycle.
    total_amount: Yup.string()
      .required("Total amount is required")
      .test(
        "is-valid-amount",
        "Total amount must be a valid number",
        (value) => {
          if (value === null || value === undefined || value === "") return false;
          const cleaned = String(value).replace(/[^0-9.]/g, "").trim();
          if (cleaned === "") return false;
          const num = parseFloat(cleaned);
          return !isNaN(num);
        }
      )
      .test(
        "not-negative",
        "Total amount cannot be negative",
        (value) => {
          if (!value) return true; // let "required" handle empty
          const cleaned = String(value).replace(/[^0-9.]/g, "").trim();
          if (cleaned === "") return true;
          return parseFloat(cleaned) >= 0;
        }
      ),

    due_date: Yup.mixed()
      .required("Due date is required")
      .test("is-valid-date", "Please select a valid due date", (v) => {
        if (!v) return false;
        const d = v?.toDate ? v.toDate() : new Date(v);
        return !isNaN(d.getTime());
      }),

    message: Yup.string().optional(),

    bill_image: requiresImage
      ? fileTests(Yup.mixed().required("Bill image or PDF is required"))
      : fileTests(Yup.mixed().nullable()),
  });
};